(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oo-hero-viewport')) {
    customElements.define('oo-hero-viewport', class extends HTMLElement {
      connectedCallback() {
        this.hero = this.closest('.hero');
        this.updateHeight = () => {
          // Measure only the space above the hero; transparent navigation already overlays it.
          const pageTop = Math.max(0, this.hero.getBoundingClientRect().top + window.scrollY);
          const headerHeight = document.getElementById('header-group')?.getBoundingClientRect().height || 0;
          const top = pageTop <= headerHeight + 1 ? pageTop : 0;
          this.hero.style.setProperty('--oo-hero-top-offset', top + 'px');
        };
        this.frame = requestAnimationFrame(this.updateHeight);
        this.viewportWidth = window.innerWidth;
        this.onResize = () => {
          // Browser toolbar changes must not resize or reposition the hero while scrolling.
          if (window.innerWidth === this.viewportWidth) return;
          this.viewportWidth = window.innerWidth;
          this.updateHeight();
        };
        window.addEventListener('resize', this.onResize);
        window.addEventListener('load', this.updateHeight);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('load', this.updateHeight);
      }
    });
  }

  if (!customElements.get('oo-responsive-hero-video')) {
    customElements.define('oo-responsive-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.breakpoint = window.matchMedia('(max-width: 749px)');
        this.refreshVideo = () => {
          const video = this.querySelector('video');
          if (!video) return;
          video.load();
          video.play().catch(() => {});
        };
        this.breakpoint.addEventListener('change', this.refreshVideo);
      }
      disconnectedCallback() {
        this.breakpoint.removeEventListener('change', this.refreshVideo);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
